<template>
  <FlowsComponent />
</template>

<script>
// @ is an alias to /src
import FlowsComponent from "@/sections/voiceplus/components/FlowsComponent.vue";

export default {
  name: "Flows",
  components: {
    FlowsComponent,
  },
};
</script>
